var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import Cookies from 'js-cookie';
import { useSaveDetailsMutation } from '@/Adminhooks/mutation/chat';
export function ChatInput(_a) {
    var { onSend, setFlag, disabled, uiFlag } = _a, props = __rest(_a, ["onSend", "setFlag", "disabled", "uiFlag"]);
    const inputRef = useRef(null);
    const [message, setMessage] = useState('');
    const [step, setStep] = useState(null);
    const [hover, setHover] = useState(false);
    const saveMutation = useSaveDetailsMutation();
    const uid = Cookies.get('user_uuid');
    useEffect(() => {
        if (uiFlag === 'session_close') {
            setStep(null);
            return;
        }
        if (uiFlag === 'all') {
            if (!step)
                setStep('request_name');
        }
        else if (uiFlag === 'request_name' ||
            uiFlag === 'request_email' ||
            uiFlag === 'request_phone') {
            setStep(uiFlag);
        }
        else {
            setStep(null);
        }
    }, [uiFlag]);
    const validate = (flag, value) => {
        if (!flag)
            return true;
        if (flag === 'request_email')
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
        if (flag === 'request_phone')
            return /^\+?[0-9]{7,15}$/.test(value);
        if (flag === 'request_name')
            return value.trim().length > 1;
        return true;
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validate(step, message))
            return;
        if (step) {
            saveMutation.mutate({
                cookie_id: uid || '',
                name: step === 'request_name' ? message : '',
                email: step === 'request_email' ? message : '',
                phone: step === 'request_phone' ? message : '',
            });
        }
        onSend === null || onSend === void 0 ? void 0 : onSend(message);
        setMessage('');
        sessionStorage.setItem('chat', 'false');
        setFlag === null || setFlag === void 0 ? void 0 : setFlag('');
        if (uiFlag === 'all') {
            if (step === 'request_name')
                setStep('request_email');
            else if (step === 'request_email')
                setStep('request_phone');
            else
                setStep(null);
        }
    };
    const handleCancel = () => {
        onSend === null || onSend === void 0 ? void 0 : onSend('I’d prefer not to share that.');
        setFlag === null || setFlag === void 0 ? void 0 : setFlag('');
        sessionStorage.setItem('chat', 'false');
        if (uiFlag === 'all')
            setStep(null);
    };
    const isDisabled = disabled || !validate(step, message) || !message.trim();
    useEffect(() => {
        if (!disabled && inputRef.current)
            inputRef.current.focus();
    }, [step, disabled]);
    return (_jsxs("form", Object.assign({}, props, { onSubmit: handleSubmit, style: {
            position: 'relative',
            height: 44,
            borderRadius: 38,
            padding: '0 12px',
            border: '1px solid rgba(255,255,255,0.3)',
            background: 'transparent',
            boxShadow: '0 20px 30px rgba(0,0,0,0.3)',
            overflow: 'hidden',
        }, children: [_jsx("div", { style: {
                    pointerEvents: 'none',
                    position: 'absolute',
                    inset: 0,
                    borderRadius: 38,
                    boxShadow: 'inset 0 4px 8px rgba(255,255,255,0.15), inset 0 -4px 8px rgba(0,0,0,0.3)',
                } }), _jsxs("div", { style: {
                    position: 'relative',
                    zIndex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%',
                    gap: 8,
                }, children: [_jsx("input", { ref: inputRef, value: message, onChange: (e) => setMessage(e.target.value), placeholder: step === 'request_name'
                            ? 'Enter your name...'
                            : step === 'request_email'
                                ? 'Enter your email...'
                                : step === 'request_phone'
                                    ? 'Enter your phone...'
                                    : 'Type something...', style: {
                            flex: 1,
                            background: 'transparent',
                            border: 'none',
                            outline: 'none',
                            color: '#fff',
                            paddingLeft: 8,
                            fontSize: 16,
                        } }), step && (_jsx("button", { type: "button", onClick: handleCancel, style: {
                            height: 40,
                            padding: '0 12px',
                            borderRadius: 999,
                            background: 'rgba(75,85,99,0.4)',
                            color: '#fff',
                            border: 'none',
                            cursor: 'pointer',
                        }, children: "Skip" })), _jsx("button", { type: "submit", disabled: isDisabled, onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false), style: {
                            height: 40,
                            width: 40,
                            borderRadius: '50%',
                            border: 'none',
                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                            opacity: isDisabled ? 0.4 : 1,
                            background: 'linear-gradient(135deg, #f472b6, #a78bfa, #60a5fa)',
                            transform: !isDisabled && hover ? 'scale(1.1)' : 'scale(1)',
                            transition: 'all 0.3s ease',
                            boxShadow: isDisabled ? 'none' : '0 10px 20px rgba(0,0,0,0.3)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }, children: _jsxs("svg", { width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", children: [_jsx("line", { x1: "22", y1: "2", x2: "11", y2: "13" }), _jsx("polygon", { points: "22 2 15 22 11 13 2 9 22 2" })] }) })] })] })));
}
